import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

export const fontFamily = 'Figtree';

export const colour = {
	gradient: "linear-gradient(90deg, #F6E882 0%, #FFA4D4 44.5%, #9D8DE7 100%)",

	// Greyscale
	gray00: "#FFFFFF",
	gray01: "#F5F5F5",
	gray02: "#E6E5EB",
	gray03: "#CBC9D4",
	gray04: "#A9A7B4",
	gray05: "#7E7B8E",
	gray06: "#2E2C34",
	gray07: "#151219",

	// Brown
	brown01: "#CDAC96",
	brown02: "#A3663E",
	brown03: "#593822",

	// Orange
	orange01: "#FED1B9",
	orange02: "#FD8F54",
	orange03: "#A63B02",

	// Yellow
	yellow01: "#FEEFBD",
	yellow02: "#F1C63C",
	yellow03: "#7C6109",

	// Green
	green01: "#CCEEBF",
	green02: "#5EC733",
	green03: "#336F1B",

	// Jade
	jade01: "#D1FAE5",
	jade02: "#63EEA8",
	jade03: "#147645",
	jade03Dark: "#14764599",

	// Aqua
	aqua01: "#CEF0F7",
	aqua02: "#77D5E9",
	aqua03: "#156D7F",

	// Blue
	blue01: "#C4DAF7",
	blue02: "#6BA2EB",
	blue03: "#185BB4",

	// Purple
	purple01: "#CFC6F1",
	purple02: "#8168D9",
	purple03: "#4A2DB4",

	// Magenta
	magenta01: "#F3AAE2",
	magenta02: "#E024B4",
	magenta03: "#8A146E",

	// Pink
	pink01: "#FFE0EF",
	pink02: "#FFA4D4",
	pink03: "#C90D65",

	// Red
	red01: "#FCCACB",
	red02: "#F7696C",
	red03: "#B70A0E",
	red03Dark: "#B70A0E99",

	heatmapHot: {red: 84, green: 3, blue: 212},
	heatmapCold: {red: 255, green: 237, blue: 70},

	heatmapHotHex: "#5304D4",
	heatmapColdHex: "#FFED46"
};

// Formatting

export const percentage = new Intl.NumberFormat('en-US', {
	style: 'percent',
	minimumFractionDigits: 0,
	maximumFractionDigits: 1,
});

export const percentageCompact = new Intl.NumberFormat('en-US', {
	style: 'percent',
	minimumFractionDigits: 0,
	maximumFractionDigits: 0,
});

export const formatterLong = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	notation: 'standard'
});

export const formatterLongNoCents = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	notation: 'standard',
	minimumFractionDigits: 0,
	maximumFractionDigits: 0
});

export const formatterCompact = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	notation: 'compact'
});

export const numberFormatter = new Intl.NumberFormat('en-US');

export const roundToAppropriateDecimals = (num) =>  {
	const val = num % 1 === 0 ? num : Math.round(num * 10) / 10;
	return val;
}

export const clusterColours = [
	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},


	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},

	{
		bg: colour.red01,
		stroke: colour.red02,
		icon: colour.red03
	},
	{
		bg: colour.green01,
		stroke: colour.green02,
		icon: colour.green03
	},
	{
		bg: colour.orange01,
		stroke: colour.orange02,
		icon: colour.orange03
	},
	{
		bg: colour.aqua01,
		stroke: colour.aqua02,
		icon: colour.aqua03
	},
	{
		bg: colour.yellow01,
		stroke: colour.yellow02,
		icon: colour.yellow03
	},
	{
		bg: colour.purple01,
		stroke: colour.purple02,
		icon: colour.purple03
	},
	{
		bg: colour.jade01,
		stroke: colour.jade02,
		icon: colour.jade03
	},
	{
		bg: colour.magenta01,
		stroke: colour.magenta02,
		icon: colour.magenta03
	},
	{
		bg: colour.blue01,
		stroke: colour.blue02,
		icon: colour.blue03
	},
	{
		bg: colour.brown01,
		stroke: colour.brown02,
		icon: colour.brown03
	},
	{
		bg: colour.pink01,
		stroke: colour.pink02,
		icon: colour.pink03
	},
	{
		bg: colour.gray03,
		stroke: colour.gray04,
		icon: colour.gray05
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
	{
		bg: colour.gray02,
		stroke: colour.gray03,
		icon: colour.gray04
	},
];

export const statusDotColours = {
	flop: colour.orange02,
	flip: colour.jade02,
	nonFlip: colour.purple02,
	sold: colour.yellow02,
	pending: colour.aqua02,
	forSale: colour.pink02
}

export const IOSSwitch = styled((props) => (
	<Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))
		(({ theme }) => ({
			width: 42,
			height: 26,
			padding: 0,
			margin: '0px !important',
			'& .MuiSwitch-switchBase': {
			  padding: 0,
			  margin: 2,
			  transitionDuration: '300ms',
			  '&.Mui-checked': {
				transform: 'translateX(16px)',
				color: '#fff',
				'& + .MuiSwitch-track': {
				  backgroundColor: theme.palette.mode === 'dark' ? colour.gray02 : colour.gray06,
				  opacity: 1,
				  border: 0,
				},
				'&.Mui-disabled + .MuiSwitch-track': {
				  opacity: 0.5,
				},
			  },
			  '&.Mui-focusVisible .MuiSwitch-thumb': {
				color: '#33cf4d',
				border: '6px solid #fff',
			  },
			  '&.Mui-disabled .MuiSwitch-thumb': {
				color:
				  theme.palette.mode === 'light'
					? theme.palette.grey[100]
					: theme.palette.grey[600],
			  },
			  '&.Mui-disabled + .MuiSwitch-track': {
				opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
			  },
			},
			'& .MuiSwitch-thumb': {
			  boxSizing: 'border-box',
			  width: 22,
			  height: 22,
			},
			'& .MuiSwitch-track': {
			  borderRadius: 26 / 2,
			  backgroundColor: colour.gray02,
			  opacity: 1,
			  transition: theme.transitions.create(['background-color'], {
				duration: 500,
			  }),
			},
			'& .MuiSwitch-input': {
				width: '100% !important'
			}
		})
);

export const mapColours = {
	mapColorsMapZoneA: colour.jade02,
	mapColorsMapZoneB: colour.jade03,
	mapColorsMapZoneBC: colour.yellow02,
	mapColorsMapZoneC: colour.purple02,
	mapColorsMapZoneD: colour.purple03,
	mapColorsMapZoneInactive: colour.gray02,
}

export const neighbourhoodColours = [
	"#FCE724B3",
	"#A0D839B3",
	"#4CC16BB3",
	"#21A186B3",
	"#277D8EB3",
	"#375B8CB3",
	"#45317DB3",
	"#440154B3",
];

export const formatUSPhone = (input) => {
	const digits = String(input).replace(/\D/g, '');

	// Allow 11‑digit numbers that start with country code “1”
	const cleaned = digits.length === 11 && digits[0] === '1'
		? digits.slice(1)
		: digits;

	if (cleaned.length !== 10) return input;     // Fallback: don’t mangle bad input

	const area   = cleaned.slice(0, 3);
	const prefix = cleaned.slice(3, 6);
	const line   = cleaned.slice(6);

	return `(${area}) ${prefix}-${line}`;
}